import { render, staticRenderFns } from "./SuggestedEVsSection.vue?vue&type=template&id=274dbd3e"
import script from "./SuggestedEVsSection.vue?vue&type=script&lang=ts"
export * from "./SuggestedEVsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports